import { DotsVerticalIcon } from "@heroicons/react/outline";
import { DropdownMenu } from "components/dropdownMenu";
import { SwitchButton } from "components/switchButton"
import { IOrgItem } from "interfaces";
import moment from "moment";
import { formattedFilterParamsString } from "providerrs";
import { isHaveActionPermission } from "utills/helpers";

interface OrgCardProps {
  data?: IOrgItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const OrgCard = ({data = [], pageSize = 10, currentPage = 1, _toggleActive }: OrgCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IOrgItem, index: number) => (
        <div key={index} className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl">
          <li className="relative flex items-center justify-between gap-x-6">
            <div>
              <SwitchButton
                checked={item.is_active}
                disabled={
                  !isHaveActionPermission(
                    "org_management",
                    "organization",
                    "edit"
                  )
                }
                onChange={() => _toggleActive(item.id, item.is_active)}
              />
            </div>
            <div className="flex flex-row items-center gap-x-2">
              <DropdownMenu
                label={<DotsVerticalIcon className="w-4" />}
                items={[
                  {
                    label: "View",
                    href: `/organization/org/${item.id}`,
                    target: "_blank",
                  },
                  ...(isHaveActionPermission(
                    "org_management",
                    "organization",
                    "edit"
                  )
                    ? [
                        {
                          label: "Edit",
                          href: `/organization/org/${item.id}/edit`,
                          target: "_blank",
                        },
                      ]
                    : []),
                  ...(isHaveActionPermission(
                    "role_management",
                    "organization",
                    "view"
                  )
                    ? [
                        {
                          label: "Role",
                          href: `/organization/roles?${formattedFilterParamsString(
                            [
                              {
                                field: "organization_id",
                                operator: "eq",
                                value: item.id,
                              },
                            ]
                          )}`,
                          target: "_blank",
                        },
                      ]
                    : []),
                  ...(isHaveActionPermission(
                    "account_management",
                    "organization",
                    "view"
                  )
                    ? [
                        {
                          label: "Account",
                          href: `/organization/accounts?${formattedFilterParamsString(
                            [
                              {
                                field: "organization_id",
                                operator: "eq",
                                value: item.id,
                              },
                            ]
                          )}`,
                          target: "_blank",
                        },
                      ]
                    : []),
                ]}
              />
            </div>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              No
            </p>
            <p className="flex-1 text-right text-sm leading-6">{(currentPage - 1) * pageSize + 1 + index}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Organization name
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.name_en}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Contact email
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.contact_email}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Contact phone
            </p>
            <p className="flex-1 text-right text-sm leading-6">{item.contact_phone}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Event type
            </p>
            <p className="flex-1 text-right text-sm leading-6 capitalize">{item.event_type.join(", ")}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Created at
            </p>
            <p className="flex-1 text-right text-sm leading-6">{moment(item.created).format("DD/MM/YYYY HH:mm:ss")}</p>
          </li>
        </div>
      ))}
    </ul>
  )
}